import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import {
  type ITextInputProps,
  TextInput,
} from "src/shared/forms/inputs/TextInput";
import { combineReduxFormValidationRules } from "src/shared/forms/validations/combineReduxFormValidationRules";
import Regex from "src/shared/forms/validations/Regex";

export interface IPhoneNoInputProps extends ITextInputProps {
  phoneRegex?: RegExp;
  disablePhoneRegex?: boolean;
}

export const PhoneNoInput = ({
  validate,
  disablePhoneRegex,
  phoneRegex,
  ...rest
}: IPhoneNoInputProps) => {
  const validations = useMemo(() => {
    return combineReduxFormValidationRules(
      !disablePhoneRegex &&
        Regex(
          phoneRegex ?? /^1(\d+)$/i,
          <FormattedMessage id="form.validations.phone_no.invalid" />,
        ),
      validate,
    );
  }, [disablePhoneRegex, phoneRegex, validate]);

  return (
    <TextInput
      isRequired
      label={<FormattedMessage id="form.phone_no" />}
      {...rest}
      validate={validations}
    />
  );
};

/**
 * @deprecated
 */
export default PhoneNoInput;
